import React from 'react';

interface VideoBannerProps {
  videoSrc: string;
  height?: number | string;
  width?: number | string;
  left?: number | string;
  right?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

const VideoBanner: React.FC<VideoBannerProps> = ({ 
  videoSrc, 
  height = '100%', 
  width = '100%',
  left,
  right,
  className = '',
  style = {}
}) => {
  // Convert height to string if it's a number
  const heightValue = typeof height === 'number' 
    ? `${height}px` 
    : height;
  
  return (
    <div
      style={{
        position: 'relative',
        left: left !== undefined ? left : 0,
        right: right !== undefined ? right : undefined,
        top: 0,
        height: heightValue,
        width: width,
        overflow: 'hidden',
        zIndex: 0,
        pointerEvents: 'none',
        ...style
      }}
      className={className}
    >
      <video
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center center',
          minWidth: 0,
          minHeight: 0,
          maxWidth: '100%',
          maxHeight: '100%',
          boxSizing: 'border-box',
          display: 'block',
          imageRendering: 'auto',
          backfaceVisibility: 'hidden',
          transform: 'translateZ(0)',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          willChange: 'transform',
        }}
      />
    </div>
  );
};

export default VideoBanner;

